module.exports = __webpack_public_path__ + "img/main1.27f269a0.png";